import { render, staticRenderFns } from "./new-checkout-card.vue?vue&type=template&id=1f21773a&scoped=true"
import script from "./new-checkout-card.vue?vue&type=script&lang=js"
export * from "./new-checkout-card.vue?vue&type=script&lang=js"
import style0 from "../checkout-card/checkout-card.scss?vue&type=style&index=0&id=1f21773a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f21773a",
  null
  
)

export default component.exports